(function () {
    angular.bootstrap(document, ['pages.master']);
})();